// extracted by mini-css-extract-plugin
export default {"place__card":"PlaceCard_place__card__pzeRA","anchor__overlay":"PlaceCard_anchor__overlay__b1SOa"};